import PASentryLog from "../pa-sentry";

export default function initLiveChat(locale: string) {
  import(/* webpackChunkName: "pa-chat-agent" */"./PAChatAgent")
    .then((module) => {
      module.default.initialize(locale);
    })
    .catch((err) => PASentryLog.logException(err, {}, { message: "Loading zendeskchat fail - componentDidMount" }));
}
